import React from 'react';

const HomeBanner = () =>{
    return (
        <>
        <div className='cadBannerHome'>
            <video className='videoTag' autoPlay loop muted>
                <source src="/videos/final-video.mp4" type='video/mp4' />
            </video>
        </div>
        </>
    );
}

export default HomeBanner;